export default __webpack_public_path__ + "static/media/Spinner-loader.57dea1ab.svg";